import { ChatCircleIcon } from "@phosphor-icons/react";
import { CommandItem } from "@/components/ui/controls/command";
import type { ChatSearchConversation } from "@/data-access/herald-chat/chat-queries";
import {
  formatChatSearchDate,
  renderChatSearchTitle,
} from "./chatSearchDialogHelpers";

export interface ChatSearchResultItemProps {
  conversation: ChatSearchConversation;
  onSelect: (conversationId: string) => void;
}

export const ChatSearchResultItem = ({
  conversation,
  onSelect,
}: ChatSearchResultItemProps) => (
  <CommandItem
    value={conversation.id}
    onSelect={() => onSelect(conversation.id)}
    size="md"
    textBehavior="normal"
    className="group h-7 min-h-0 cursor-pointer gap-3 rounded-xs px-5 py-0 text-sm font-normal leading-5 tracking-[0.14px] text-gray-900 data-[selected=true]:bg-gray-100 data-[selected=true]:font-normal data-[selected=true]:text-gray-900 aria-selected:bg-gray-100 aria-selected:font-normal aria-selected:text-gray-900"
  >
    <ChatCircleIcon className="size-3.5 shrink-0 text-gray-600" />
    <span className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
      {renderChatSearchTitle(conversation.title, conversation.searchMatch)}
    </span>
    <span className="ml-auto shrink-0 text-xs font-normal leading-5 tracking-[0.12px] text-gray-700 group-data-[selected=true]:text-gray-700 group-aria-selected:text-gray-700">
      {formatChatSearchDate(conversation.updatedAt)}
    </span>
  </CommandItem>
);
